import { OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subject } from 'rxjs';
import { Complaint } from '../complaint.model';
import { takeUntil } from 'rxjs/operators';
var ComplaintFormDialogComponent = /** @class */ (function () {
    /**
     * Constructor
     *
     * @param {MatDialogRef<ComplaintFormDialogComponent>} matDialogRef
     * @param _data
     * @param {FormBuilder} _formBuilder
     */
    function ComplaintFormDialogComponent(matDialogRef, _data, _complaintService, _formBuilder, _matSnackBar, _companyService, _translate, _translationLoader) {
        this.matDialogRef = matDialogRef;
        this._data = _data;
        this._complaintService = _complaintService;
        this._formBuilder = _formBuilder;
        this._matSnackBar = _matSnackBar;
        this._companyService = _companyService;
        this._translate = _translate;
        this._translationLoader = _translationLoader;
        this.lang = 'sr';
        this._unsubscribeAll = new Subject();
        // Set the defaults
        this.action = _data.action;
        this.dialogTitle = 'New complaint';
        this.complaint = new Complaint({});
        this.complaintForm = this.createComplaintForm();
    }
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    ComplaintFormDialogComponent.prototype.getTranslations = function () {
        var _this = this;
        this._translationLoader.getLastLang()
            .then(function (response) {
            _this.lang = response['code'];
            _this._translationLoader.getTranslations(_this.lang, '23');
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function () {
        }, function (err) {
        });
    };
    Object.defineProperty(ComplaintFormDialogComponent.prototype, "f", {
        // convenience getter for easy access to form fields
        get: function () { return this.complaintForm.controls; },
        enumerable: true,
        configurable: true
    });
    ComplaintFormDialogComponent.prototype.checkTypeChange = function (type) {
        this.selectedType = type.triggerValue;
    };
    /**
     * Create city form
     *
     * @returns {FormGroup}
     */
    ComplaintFormDialogComponent.prototype.createComplaintForm = function () {
        return this._formBuilder.group({
            id: [this.complaint.id],
            type: [this.complaint.type],
            comment: [this.complaint.comment]
        });
    };
    ComplaintFormDialogComponent.prototype.checkServerError = function (fieldName) {
        return this.complaintForm.get(fieldName).errors ? this.complaintForm.get(fieldName).errors.serverError ?
            this.complaintForm.get(fieldName).errors.serverError : this._translate.instant('This field is required!') : false;
    };
    ComplaintFormDialogComponent.prototype.createComplaint = function (complaintForm) {
        var _this = this;
        this._complaintService.createComplaint(complaintForm.getRawValue().type, complaintForm.getRawValue().comment, this.company.id)
            .then(function (x) {
            _this.matDialogRef.close(['save', complaintForm]);
            // Show the success message
            _this._matSnackBar.open(_this._translate.instant('Complaint') + ' ' + complaintForm.getRawValue().type + _this._translate.instant(' created successfully.'), '', {
                verticalPosition: 'top',
                horizontalPosition: 'right',
                duration: 2000
            });
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function (x) { }, function (err) {
            var formControl = _this.complaintForm.get('complaint');
            console.log(err);
            if (formControl) {
                formControl.setErrors({
                    serverError: err.error.message
                });
            }
            console.log('Error:', err.statusText);
        });
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    ComplaintFormDialogComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._companyService.getActiveCompany()
            .then(function (response) {
            _this.company = response;
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function () {
            _this._complaintService.getAllComplaintTypes(_this.company.id)
                .then(function (response) {
                _this.complaintTypes = response.data;
                console.log(_this.complaintTypes);
            });
        }, function (err) {
        });
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (value) {
            _this.getTranslations();
        });
        this.getTranslations();
    };
    ComplaintFormDialogComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    };
    return ComplaintFormDialogComponent;
}());
export { ComplaintFormDialogComponent };
